export const uiMarkdown = {
    name: 'UI Markdown',
    description: '',
    displayField: 'content',
    fields: {
        content: {
            name: 'Content',
            type: 'Text',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        textSize: {
            name: 'Text Size',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Large', 'Small'] }]
        }
    }
};
//# sourceMappingURL=uiMarkdown.js.map